import { environment } from '@environments/environment';
import { PushMessageType } from '@push-message/push-message';

export class Ad6Constants {
  static readonly ENDPOINT = `${environment.backendUrl}/v1`;

  static readonly IMPORT_START_NUMBERS_ENDPOINT = `${Ad6Constants.ENDPOINT}/import/participants`;

  static readonly CONFIG_ENDPOINT = `${Ad6Constants.ENDPOINT}/app`;
  static readonly CONFIG_ENDPOINT_SEARCH = `${Ad6Constants.CONFIG_ENDPOINT}/find`;

  static readonly CONFIG_VALUE_ENDPOINT = `${Ad6Constants.ENDPOINT}/appconfig`;
  static readonly CONFIG_VALUE_ENDPOINT_SEARCH = `${Ad6Constants.CONFIG_VALUE_ENDPOINT}/find`;

  static readonly EVENT_ENDPOINT = `${Ad6Constants.ENDPOINT}/events`;
  static readonly EVENT_SEARCH_ENDPOINT = `${Ad6Constants.EVENT_ENDPOINT}/find`;

  static readonly EVENT_SETTING_ENDPOINT = `${Ad6Constants.ENDPOINT}/eventsettings`;

  static readonly PARTICIPANT_ENDPOINT = `${Ad6Constants.ENDPOINT}/participants`;
  static readonly PARTICIPANT_SEARCH_ENDPOINT = `${Ad6Constants.PARTICIPANT_ENDPOINT}/find`;

  static readonly PUSHMESSAGE_ENDPOINT = `${Ad6Constants.ENDPOINT}/pushmessages`;
  static readonly PUSHMESSAGE_SEARCH_ENDPOINT = `${Ad6Constants.PUSHMESSAGE_ENDPOINT}/find`;

  static readonly SUB_EVENT_ENDPOINT = `${Ad6Constants.ENDPOINT}/subevents`;

  static readonly TEAM_ENDPOINT = `${Ad6Constants.ENDPOINT}/teams`;
  static readonly TEAM_SEARCH_ENDPOINT = `${Ad6Constants.TEAM_ENDPOINT}/find`;

  static readonly IMAGE_ENDPOINT = `${Ad6Constants.ENDPOINT}/image`;
  static readonly IMAGE_COLLECTION_ENDPOINT = `${Ad6Constants.ENDPOINT}/imagecollections`;
  static readonly IMAGE_COLLECTION_SEARCH_ENDPOINT = `${Ad6Constants.IMAGE_COLLECTION_ENDPOINT}/find`;

  static readonly TRANSLATION_GROUP_SEARCH_FIELD = 'code';
  static readonly TRANSLATION_ENDPOINT = `${Ad6Constants.ENDPOINT}/translations`;
  static readonly TRANSLATION_SEARCH_ENDPOINT = `${Ad6Constants.TRANSLATION_ENDPOINT}/find`;

  static readonly DEFAULT_LANGUAGE = 'nl';
  static readonly DISMISS_DELAY_TOAST = 5000;
  static readonly DAILOG_ACTION_OK = 'OK';

  static readonly ROLE_ADMINISTRATORS = 'Administrators';
  static readonly ROLE_AD6USER = 'AD6User';
  static readonly ROLE_GUEST = 'Guest';

  static readonly DEBOUNCE_TIME = 500; // in milliseconds

  static readonly TYPE_LAP: PushMessageType = 'lap';
}
